import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import { ScrollAnim } from "~/src/components";

import { fonts } from "~/src/config/vars";

const EditorHeader = ({ level = 2, children, ...rest }) => {
    return (
        <ScrollAnim type="slideInDownSmall" delay={0}>
            {level === 1 && <SH1 {...rest}>{children}</SH1>}
            {level === 2 && <SH2 {...rest}>{children}</SH2>}
            {level === 3 && <SH3 {...rest}>{children}</SH3>}
            {level === 4 && <SH4 {...rest}>{children}</SH4>}
            {level === 5 && <SH5 {...rest}>{children}</SH5>}
        </ScrollAnim>
    );
};

EditorHeader.propTypes = {
    level: PT.oneOf([1, 2, 3, 4, 5]).isRequired,
    children: PT.any,
    dangerouslySetInnerHTML: PT.any,
};

const SHeaderStyle = {
    padding: "22px 0",
    margin: "0 0 -0.5em",
    fontWeight: fonts?.fw_medium,
};

const SH1 = styled.h1`
    ${SHeaderStyle};
    padding-top: 0;
    font-size: ${fonts?.fs_48};
`;
const SH2 = styled.h2`
    ${SHeaderStyle};
    font-size: ${fonts?.fs_32};
`;
const SH3 = styled.h3`
    ${SHeaderStyle};
    font-size: ${fonts?.fs_20};
`;
const SH4 = styled.h4`
    ${SHeaderStyle};
    font-weight: ${fonts?.fw_bold};
    font-size: ${fonts?.fs_24};
`;
const SH5 = styled.h5`
    ${SHeaderStyle};
    font-weight: ${fonts?.fw_bold};
    font-size: ${fonts?.fs_18};
`;

export default EditorHeader;
